import { GoogleMapsAPIProvider } from "apps/commons/components/GoogleMapsAPIProvider";
import { VStack } from "apps/commons/components/Stack";
import { scrollToTop } from "apps/commons/functions/scrollToTop";
import { locationBinder } from "libs/analytics/binders/onboarding/location";
import { useAnalytics } from "libs/analytics/useAnalytics";
import type { PropertyData } from "libs/codegen/property-onboarding";
import { useEffect } from "react";
import { useWatch } from "react-hook-form";
import { Title } from "../Title";
import { originSourceMapper } from "../originSourceMapper";
import { useStaticDataAtomValue } from "../staticDataAtom";
import { usePropertyContext } from "../usePropertyContext";
import { LocationFormFields } from "./LocationFormFields";

export const LocationPage = () => {
    const {
        cmsData: {
            location: { location },
        },
    } = useStaticDataAtomValue();

    const propertyId = useWatch<PropertyData>({ name: "propertyId" }) as number;
    const { originSource } = usePropertyContext(propertyId);

    const isManualFlow =
        originSource !== originSourceMapper.AirbnbImport &&
        originSource !== originSourceMapper.BcomImport &&
        originSource !== originSourceMapper.RakutenImport &&
        originSource !== originSourceMapper.RakutenOyadoImport;

    useEffect(() => {
        scrollToTop();
    }, []);

    useAnalytics(locationBinder);

    return (
        <GoogleMapsAPIProvider>
            <VStack gap="24" pb="32">
                <Title title={location} />
                <LocationFormFields showPin={!isManualFlow} />
            </VStack>
        </GoogleMapsAPIProvider>
    );
};
